module.exports = __webpack_public_path__ + "eceb4d638e059397025fd1e14f12bb62.svg";